export default __webpack_public_path__ + "media/images/paylogos/color/mastercard-5c24204faacabe92ac5c8a95c80bd2ea.png";